export default __webpack_public_path__ + "packs/static/media/beep.93a3d71a.mp3";